import './assets/css/main.css';

import { createApp } from 'vue';
import { createPinia } from 'pinia';

import App from './App.vue';
import { router } from './router';
import i18n from './i18n';
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import ToastProvider from "@/components/ui/toast/ToastProvider.vue";

import * as Sentry from "@sentry/vue";

const toastOptions = {
    position: "top-right",
    timeout: 2000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: false,
    hideProgressBar: false,
    closeButton: "button",
    icon: true,
    rtl: false
} as const;

// Cast App component to resolve type issues
const app = createApp(App as any);

Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
});

app.use(createPinia());
app.use(router);
app.use(Toast, toastOptions);
// Cast ToastProvider to resolve component registration type issues
app.component('ToastProvider', ToastProvider as any);
app.use(i18n).mount('#app');